import styled from 'styled-components'

export const Main = styled.div`
    display: flex;
    justify-content: center;
    align-items: center;
    min-height: calc((100vh - 90px) - 50px);

.cadastro {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    margin: 50px 20px;
    width: 100%;
    height: 100%;
    max-width: 832px;
    background: ${(props) => {return props.theme.colorSecoundary}};
    box-shadow: 0px 4px 50px rgba(0, 0, 0, 0.25);
    border-radius: 20px;
    padding: 50px 80px;

    @media screen and (max-width: 450px){
        padding: 320px 15px;
        padding: 15px;
    }
}

.cadastro img {
    margin-bottom: 50px;
}

.cadastro .form-group {
    width: 100%;
}

.cadastro label {
    font-size: 24px;
    line-height: 29px;
    color: #000F1A;
    font-weight: 500;
    width: 100%;
}

.cadastro input {
    width: 100%;
    height: 37px;
    background: ${(props) => {return props.theme.colorSecoundary}};
    border: 2px solid #A7BABE;
    box-sizing: border-box;
    border-radius: 10px;
    font-size: 14px;
    line-height: 15px;
    margin-top: 5px;
}

.cadastro button {
    width: 100%;
    max-width: 324px;
    height: 37px;
    margin: 15px 0;
    font-size: 24px;
    line-height: 30px;
}

.cadastro p {
    font-size: 18px;
    line-height: 22px;
    margin-top: 10px;
}

.cadastro a {
    font-weight: bold;
    font-size: 24px;
    line-height: 29px;
    color: ${(props) => {return props.theme.colorPrimary}};
    margin: 15px 0;
}
`
